import { render, staticRenderFns } from "./detailsInfo.vue?vue&type=template&id=5e54fac0&"
import script from "./detailsInfo.vue?vue&type=script&lang=js&"
export * from "./detailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./detailsInfo.vue?vue&type=style&index=0&id=5e54fac0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports